import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import AspectRatio from 'components/ui/AspectRatio'
import Button from 'components/ui/Button'
import { BodyCopy, Subtitle, Headline4 } from 'components/ui/Typography'
import BriefContent from './BriefContent'
import { hasBrief } from './briefUtils'

import s from './TeamSection.module.scss'
const cn = classNames.bind(s)

const Item = ({ image, name, position, brief, column1, column2, callback, shape, onReadMore }) => {
  const shapeRef = useRef(null)
  const imageSrc = image?.childImageSharp?.fluid?.src
  const ratio = parseFloat(image?.childImageSharp?.fluid?.aspectRatio?.toFixed(1)) || 1
  const briefPresent = hasBrief(brief)
  const hasLightboxContent = hasBrief(column1) || hasBrief(column2)
  const hasContent = name !== '' || position !== '' || briefPresent || hasLightboxContent

  const handleReadMore = () => {
    if (!hasLightboxContent || !onReadMore || !shapeRef.current) return

    onReadMore({
      name,
      position,
      column1,
      column2,
      originRect: shapeRef.current.getBoundingClientRect(),
      shape,
    })
  }

  return (
    <div className={cn('item')} onMouseLeave={hasContent ? callback : undefined}>
      <div className={cn('image')}>
        <AspectRatio ratio={ratio}>{imageSrc && <img src={imageSrc} alt={image?.alt || name} />}</AspectRatio>
      </div>
      {hasContent && (
        <div className={cn('contentWrapper')}>
          <div ref={shapeRef} className={cn('shape', shape)} />
          <div className={cn('info', shape)}>
            {name && (
              <div className={cn('name')}>
                <Headline4>{name}</Headline4>
              </div>
            )}
            {position && (
              <div className={cn('position')}>
                <Subtitle as="h6">{position}</Subtitle>
              </div>
            )}
            {(briefPresent || hasLightboxContent) && (
              <div className={cn('brief')}>
                {briefPresent && (
                  <div className={cn('briefText')}>
                    <BriefContent content={brief} />
                  </div>
                )}
                {hasLightboxContent && (
                  <BodyCopy className={cn('readMore')}>
                    <Button onClick={handleReadMore} shouldTransitionIn={false}>
                      Read more
                    </Button>
                  </BodyCopy>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
Item.propTypes = {
  image: PropTypes.object,
  name: PropTypes.string,
  position: PropTypes.string,
  brief: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  column1: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  column2: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  callback: PropTypes.func,
  shape: PropTypes.string,
  onReadMore: PropTypes.func,
}

export default Item
